import React, { useContext } from "react";

import { Box, Typography, TextField, Button } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import InputMask from "react-input-mask";

import useStyles from "../../styles";
import { AutoRegistrationContext } from "../../../../context/AutoRegistrationProvider";
import apiV2 from "../../../../../../api/api-client-v2";
import { toast } from "react-toastify";
import { validationSchema } from "./validationSchema";
import { useFormik } from "formik";

export const ConfirmOne = ({ changeStep }) => {
  const { setStep, data, setData } = useContext(AutoRegistrationContext);
  const classes = useStyles();

  const handleSubmitForm = ({ cellphone }) => {
    if (!cellphone) return;
    apiV2
      .post("twilio/verify", {
        phone: `+${cellphone?.replaceAll(/\D/g, "")}`,
      })
      .then((reponse) => {
        toast.success(`Código enviado para: ${cellphone}`);
        setData({
          ...data,
          phoneNumber: `+${cellphone?.replaceAll(/\D/g, "")}`,
        });
        changeStep(2);
      })
      .catch((error) => {
        console.error(error);
        toast.error(error?.reponse?.data?.title);
      });
  };

  const formik = useFormik({
    initialValues: {
      cellphone: data?.phoneNumber || "",
    },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const isDisabledBtn = () => {
    const onlyNumber = formik.values.cellphone.replaceAll(/\D/g, "");

    if (onlyNumber.length === 13) {
      return false;
    }
    return true;
  };

  const isDisabledBtnIntl = () => {
    const onlyNumber = formik.values.cellphone.replaceAll(/\D/g, "");

    if (onlyNumber.length > 8) {
      return false;
    }
    return true;
  };

  const handleGoBack = () => {
    setData({
      ...data,
      phoneNumber: "",
    });
    setStep(2);
  };

  return (
    <form onSubmit={formik.handleSubmit} className={classes.form}>
      <Box className={classes.registrationContainer}>
        <Box className={classes.title}>
          <Typography>Etapa 1 de 2</Typography>
          <Typography variant="h4">Confirme seu número de celular</Typography>
        </Box>
        <Box className={classes.inputContainer}>
          <Typography variant="h5" align="left">
            Celular*
          </Typography>
          {data?.typeDocument === "intl" ? (
            <TextField
            variant="outlined"
            id="cellphone-inp"
            name="cellphone"
            data-cy="celphone-inp"
            helperText={!!formik.errors.cellphone && formik.errors.cellphone}
            error={!!formik.errors.cellphone}
            placeholder="+XX (XX) XXXXX - XXXX"
            onChange={formik.handleChange}
            />
          ):(
              <InputMask
              mask="+55 (99) 99999-9999"
              value={formik.values.cellphone}
              onChange={formik.handleChange}
            >
              <TextField
                variant="outlined"
                id="cellphone-inp"
                name="cellphone"
                data-cy="celphone-inp"
                helperText={!!formik.errors.cellphone && formik.errors.cellphone}
                error={!!formik.errors.cellphone}
                placeholder="+55 (XX) XXXXX - XXXX"
              />
            </InputMask>
          )}

          <Typography className={classes.infoText}>
            Será enviado um código via SMS para confirmar o número
            informado.
          </Typography>
        </Box>

        <Box className={classes.actionButtons}>
          <Button
            id="goBack-btn"
            data-cy="goBack-btn"
            variant="outlined"
            className="goBack"
            color="primary"
            type="button"
            onClick={handleGoBack}
            size="large"
          >
            <ArrowBackIosIcon /> Voltar
          </Button>
          <Box className="goNext">
            *Preenchimento obrigatório.
            <Button
              id="next-btn"
              data-cy="next-btn"
              variant="contained"
              className="next"
              color="primary"
              size="large"
              type="submit"
              disabled={data?.typeDocument === "intl" ? isDisabledBtnIntl() : isDisabledBtn()}
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </Box>
    </form>
  );
};
